module.exports = __webpack_public_path__ + "img/bgtop2x.eae57f3f.png";